import React, { useEffect, useRef } from "react";
import { StyledBody, StyledModal, HeaderText, CommonButtonPopup, CommonButtonBorder, StyledTextArea, StyledTextAreaAutoSize, ProfileImageContainer, PreviewImage, WellbeingPillarsCard, WellbeingPillarContainer, CustomCheckBox, TagUserCard, StyledInput } from "./styles";
import PropTypes from "prop-types";
import { InputContainer, StyledLabel } from "../CreateEvent/style";
import { Modal } from "react-bootstrap";
import { Divider, ManagerIconContainer} from "../Manager/styles";
import { closeIcon, CloseIconBranding, DropIcon, RecognitionTickIcon, UploadHDMIcon } from "../../utils/icons";
import { checkImage, fetchApi, getOrientation, resetOrientation } from "../../utils/methods";
import { uploadProfile } from "../../redux/actions";
import { toast } from "react-toastify";
import { ImageUrl } from '../../utils/constants'; 
import { imageErrorMessage } from "../../utils/constants";
import { AddUpdateAboutYourself, AddUpdateCoachEducationCertificateDetails, AddUpdateCoachingStylesDetails, AddUpdateCoachPersonality, AddUpdateCoachProfileDetails, GetCoachLanguages, AddUpdateWellbeingPillars, GetWellbeingPillarsData } from "../../redux/constants/apiConstants";
function ProfileDetailsPopup({ showModal, closeModal,userName,coachData,setStepForPopup,step,editState,GetCoachProfileData, employeeId, loggedInUserID,toggleDropdown,dropdownOpen  }) {
  const textareaRef = useRef(null);
  const [title, setTitle] = React.useState("");
  const [certificateDescription, setCertificateDescription] = React.useState("");
  const [favoriteVeggieFruit, setFavoriteVeggieFruit] = React.useState("");
  const [favoritePlace, setFavoritePlace] = React.useState("");
  const [wellnesSuperpower, setWellnesSuperpower] = React.useState("");
  const [coachingStyle, setCoachingStyle] = React.useState("");
  const [clientType, setClientType] = React.useState("");
  const [experience, setExperience] = React.useState();
  const [coachName, setCoachName] = React.useState(userName || "");
  const [headline, setHeadline] = React.useState("");
  const [imgSrc, setImgSrc] = React.useState(null);
  const fileInputRef = React.useRef();
  const [baseImage, setBaseImage] = React.useState(""); 
  const [selectedPillars, setSelectedPillars] = React.useState([]);
  const [expanded,setExpanded] = React.useState([]);
  const [selectedSubCategories, setSelectedSubcategories] = React.useState([]);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const  [selectedAreas, setSelectedAreas] = React.useState([]);
  const [coachLanguages, setCoachLanguages] = React.useState([]);


  useEffect (() => {
    if(editState){
      setTitle(coachData?.about_yourself || "");
      setCertificateDescription(coachData?.health_coach_education_certification?.[0]?.education_certificate || "");
      setFavoriteVeggieFruit(coachData?.spirit_veggie_or_fruit || "");
      setFavoritePlace(coachData?.favorite_place_to_vacation || "");
      setWellnesSuperpower(coachData?.wellness_superpower || "");
      setCoachingStyle(coachData?.coaching_style || "");
      setClientType(coachData?.client_type_focus || "");
      setExperience(coachData?.years_of_experience ? String(coachData?.years_of_experience) : null);
      setHeadline(coachData?.headline || "");
      setImgSrc(coachData?.profile_image ? coachData?.profile_image : null);
      const preSelectedPillars = coachData?.health_coach_wellness_pillars || [];
      const preselected = preSelectedPillars.map((pillar) => ({
        ...pillar,
        id: pillar.pillar_id, // make sure IDs match your selectedAreas
      }));
      
      setSelectedPillars(preselected);
      // setSelectedPillars(preSelectedPillars);
      const preSelectedSubs = [];
      preSelectedPillars.forEach((pillar) => {
        pillar.sub_pillars.forEach((sub) => {
          preSelectedSubs.push(sub.id);
        });
      });
      setSelectedSubcategories(preSelectedSubs);
      const preSelectedLangs = coachData?.health_coach_languages || [];
      setSelectedItems(preSelectedLangs);
    }
  
  },[editState])

  // Adjust height when value or defaultValue changes
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      if(textarea?.scrollHeight > 604){
        textarea.style.height = "604px"; // reset

      }else{
        textarea.style.height = "48px"; // reset
        textarea.style.height = (textarea.scrollHeight + 2) + "px"; // adjust based on content
      }
    }
  }, [certificateDescription,wellnesSuperpower,favoritePlace,favoriteVeggieFruit,step]);



  useEffect(() => {
    if(coachData){
      setImgSrc(coachData?.profile_image);
    }else{
      setImgSrc(null);
    } 
  }, [coachData]);


  const onChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return; // ✅ prevent error if nothing selected

    if (checkImage(e.target.files)) {
      if (file.size / 1000000 <= 20) {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onloadend = () => {
          // setImgSrc(reader.result);
          setBaseImage(reader.result);


          getOrientation(file, (or) => {
            resetOrientation([reader.result], or, (baseImage) => {
              uploadProfile({ profile_image: baseImage });
              // setImgSrc(baseImage);
              setBaseImage(baseImage);
            });
          });
        };
      } else {
        toast.error("Please select image file max 800px");
        if (fileInputRef.current) fileInputRef.current.value = "";
      }
    } else {
      toast.error(imageErrorMessage);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };



  const onChangeInput = (e) => {
    const { name, value } = e.target;
    if (name === "title") {
      setTitle(value);
    }else if( name === "coachName"){
      setCoachName(value);
    }
    else if(name==="experience"){
      const numericValue = value.replace(/\D/g, ""); 
      setExperience(numericValue);
    }
    else if(name==="clientType"){
      setClientType(value);
    }
    else if(name==="coachingStyle"){
      setCoachingStyle(value);
    }
   
  }


  const onChangeInputDetails = (e) => {
    const { name, value } = e.target;
    if (name === "certificateDescription") {
      setCertificateDescription(value);
      // let arr = value
      //   .split(",")          // split by comma
      //   .map((s) => s.trim())  // remove spaces around each item
      //   .filter(Boolean);    // remove empty values
      // setEducationData(arr);

    }else if (name === "favoriteVeggieFruit") {
      setFavoriteVeggieFruit(value);
    }else if (name === "favoritePlace") {
      setFavoritePlace(value);
    }else if (name === "wellnesSuperpower") {
      setWellnesSuperpower(value);
    } 
    else if (name === "headline") {
      setHeadline(value);
    }
  }

  useEffect(()=> {
    GetWellbeingPillarsAndSubPillars();
    GetCoachLanguageData();
  },[])


  useEffect(() => {
    setCoachName(userName || "");
  }, [userName]);
  

  const SaveCoachProfileDetails = async () => {
    const payload = {
      updated_profile_image: baseImage,
      headline: headline,

    };

    const coach_id = employeeId || loggedInUserID;
    const apiUrl = AddUpdateCoachProfileDetails;
    try {
      const res = await fetchApi(apiUrl, "POST", payload);
      if (res.status === "success") {
        toast.success(res.message);
        if(editState){
          closeModal();
          GetCoachProfileData(coach_id);
        }
        setStepForPopup(2);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };



  const SaveAboutDetails = async () => {
    const payload = {
      about_yourself: title,
    };
    const coach_id = employeeId || loggedInUserID;
    const apiUrl = AddUpdateAboutYourself;
    try {
      const res = await fetchApi(apiUrl, "POST", payload);
      if (res.status === "success") {
        toast.success(res.message);
        if(editState){
          closeModal();
          GetCoachProfileData(coach_id);
        }
        setStepForPopup(5);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };




  const SaveWellbeingPillarsDetails = async () => {
    // const payload = {
    //   well_being_pillars: selectedPillars.map((pillar, index) => {
    //     const subForThis = selectedSubCategories
    //       .filter((s) => s.startsWith(`${pillar.id}-`))
    //       .map((s) => {
    //         const [, subId] = s.split("-");
    //         return { sub_pillar_id: Number(subId) };
    //       });
    //     return {
    //       pillar_id: pillar.id,
    //       priority: index + 1, // priority = order selected
    //       sub_pillars: subForThis
    //     };
    //   }),
    // };

    const payload = {
      well_being_pillars: selectedPillars.map((pillar, index) => {
        // filter only sub_pillars that are selected
        const fullPillar = selectedAreas.find((p) => p.id === pillar.id);
        const selectedSubs = fullPillar.sub_pillars
          .filter((sub) => selectedSubCategories.includes(sub.id))
          .map((sub) => ({ sub_pillar_id: sub.id }));
        // const selectedSubs = pillar.sub_pillars 
          // .filter((sub) => selectedSubCategories.includes(sub.id))
          // .map((sub) => ({ sub_pillar_id: sub.id }));
  
        return {
          pillar_id: pillar.id,
          priority: index + 1, 
          sub_pillars: selectedSubs,
        };
      }),
    };

    const coach_id = employeeId || loggedInUserID;
  
    try {
      const res = await fetchApi(AddUpdateWellbeingPillars, "POST", payload);
      if (res.status === "success") {
        toast.success(res.message);
        if(editState){
          closeModal();
          GetCoachProfileData(coach_id);
        }
        setStepForPopup(4);
      } else {
        toast.error(res.data?.message || "Something went wrong");
      }
    } catch (error) {
      window.console.error(error);
    }
  };



  const SaveCoachStylesDetails = async () => {
    const payload = {
      languageIds: selectedItems.map((i) => i.id), 
      coaching_style: coachingStyle,
      client_type_focus: clientType,
      years_of_experience: Number(experience),
    };
    const coach_id = employeeId || loggedInUserID;

    const apiUrl = AddUpdateCoachingStylesDetails;

    try {
      const res = await fetchApi(apiUrl, "POST", payload);
      if (res.status === "success") {
        toast.success(res.message);
        if(editState){
          closeModal();
          GetCoachProfileData(coach_id);
        }
        setStepForPopup(7);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };



  const SaveEducationCertificationDetails = async () => {
    const payload = {
      education_certification: [
        {
          education_certificate_title:certificateDescription
        }
      ]
    };
    const coach_id = employeeId || loggedInUserID;

    const apiUrl = AddUpdateCoachEducationCertificateDetails;

    try {
      const res = await fetchApi(apiUrl, "POST", payload);
      if (res.status === "success") {
        toast.success(res.message);
        if(editState){
          closeModal();
          GetCoachProfileData(coach_id);
        }
        setStepForPopup(6);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };


  

  // const GetWellbeingPillarsAndSubPillars = async () => {
  //   const apiUrl = GetWellbeingPillarsData;
  //   try {
  //     const res = await fetchApi(apiUrl,"GET");
  //     window.console.log("res here issss", res);
  //     if(res.status === "success"){
  //       // setSelectedAreas(res.data);
  //       // const selectedPillars = res.data.filter(
  //       //   (pillar) => pillar.user_selected_pillar_priority > 0
  //       // );
  //       setSelectedAreas(res.data);

  
  //     //   if (selectedPillars.length > 0 && editState) {
  //     //     // If some pillars have priority set, show only them
  //     //     // setSelectedAreas(selectedPillars);
  //     //     setPreSelectedPillars(selectedPillars);
  //     //   } else {
  //     //     // Otherwise, show all pillars
  //     //     setSelectedAreas(res.data);
  //     //   }
  //     //   // setWellbeingPillars(res.data.pillars || []);
  //     //   // setWellbeingSubPillars(res.data.sub_pillars || []);
  //     }else{
  //       toast.error(res.message);
  //     }
  //   }
  //   catch(error){
  //     window.console.error(error);
  //   }
  // }


  const GetWellbeingPillarsAndSubPillars = async () => {
    const apiUrl = GetWellbeingPillarsData;
    try {
      const res = await fetchApi(apiUrl,"GET");
      if(res.status === "success"){
        const data = res.data.map((pillar) => ({
          ...pillar,
          // unify the property name
          normalized_priority: pillar.user_selected_pillar_priority || pillar.priority || 0
        }));
        setSelectedAreas(data);
        // pre-fill selected pillars if any priority is set
        const preselected = data.filter((p) => Number(p.normalized_priority) > 0);
        setSelectedPillars(preselected);
  
      } else {
        toast.error(res.message);
      }
    } catch(error) {
      window.console.error(error);
    }
  };
  

  const GetCoachLanguageData = async () => {
    const apiUrl = GetCoachLanguages;
    try {
      const res = await fetchApi(apiUrl,"GET");
      if(res.status === "success"){
        setCoachLanguages(res.data);
        setSelectedItems(res.data.filter((item) => item.is_selected_by_coach === 1)); // preselect
      }else{
        toast.error(res.message);
      }
    }
    catch(error){
      window.console.error(error);
    }
  }



  const SavePersonalityDetails = async () => {
  
    const payload = {
      spirit_veggie_or_fruit: favoriteVeggieFruit,
      favorite_place_to_vacation: favoritePlace,
      wellness_superpower: wellnesSuperpower,
    };
    const coach_id = employeeId || loggedInUserID;
    const apiUrl = AddUpdateCoachPersonality;
    try {
      const res = await fetchApi(apiUrl, "POST", payload);
      if (res.status === "success") {
        toast.success(res.message);
        closeModal();
        GetCoachProfileData(coach_id);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };



  const stepOneForm = () => {
    window.console.log("stepOneForm");
    return (
      <>
        <Modal.Header closeButton onHide={closeModal} style={{ background: "white" }}>
          <HeaderText>
            <div className="subContainer">
              <div className="popupHeading">Create Your Coaching Profile</div>
              {editState ? <div className="closeIcon" onClick={()=>closeModal()}>{CloseIconBranding("#092F41")}</div>:null}
            </div>
            <div className="popupSubHeading">Your profile is your first impresssion - add a picture, your name and a headline that shows your style.</div>
          </HeaderText>
         
        </Modal.Header>
        <StyledBody  isOverFlow={"hidden"}>
          <StyledLabel isFont={"14px"} color={"#184A61"} marginb={"12px"} margin="0px" symbolSize={"14px"}>Profile image {<span className="imp">*</span>}</StyledLabel>
          <>
            <input
              type="file"
              id="profle-file"
              ref={fileInputRef}
              onChange={onChange}
              style={{ display: "none" }}
            />
            {(baseImage || imgSrc) ? (
              <PreviewImage  onClick={() => fileInputRef.current && fileInputRef.current.click()}
                style={{ cursor: "pointer" }}>
                <img  src={baseImage || `${ImageUrl}/${imgSrc}` }  alt="profile" /> 
                {/* <img  src={baseImage || imgSrc }  alt="profile" />  */}
              </PreviewImage>
            ) : (
              <ProfileImageContainer>
               
                <div
                  className="middle-section"
                  onClick={() => fileInputRef.current && fileInputRef.current.click()}
                >
                  <div className="iconContainer">{UploadHDMIcon()}</div>
                  <div className="title">Upload File</div>
                  <div className="sub-title">(.jpeg, .png)</div>
                </div>
              </ProfileImageContainer>
            )}
          </>

          <div className="min-max-text" >Min 400px, Max 800px</div>

          <InputContainer>
            <StyledLabel isFont={"14px"} color={"#184A61"} margin="16px"  marginb={"12px"} symbolSize={"14px"}>Name</StyledLabel>
            <StyledInput
              placeholder={("Enter name")}
              name="coachName"
              onChange={onChangeInput}
              value={coachName}
              maxLength="30"
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
              disabled={true}
            />
          </InputContainer>
          <InputContainer>
            <StyledLabel isFont={"14px"} color={"#184A61"} margin="16px" symbolSize={"14px"} marginb={"12px"}>Headline</StyledLabel>
            {/* <StyledTextArea
              placeholder={("E.g., Certified Health Coach | Mindfulness Advocate | Fitness Mentor")}
              name="headline"
              height={"48px"}
              maxLength={100}
              onChange={handleTextAreaChange}
              value={headline}
              isPadding={"12px"}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
            /> */}
            <StyledTextAreaAutoSize
              rows={1} //
              isHeight={"auto"}
              placeholder={("E.g., Certified Health Coach | Mindfulness Advocate | Fitness Mentor")}
              isBorderColor={headline?.length > 100 ? "1px solid #DA6C74" : " 1px solid #BDBDBD"}
              name="headline"
              onChange={handleTextAreaChange}
              value={headline}
              isPadding={"12px"}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
              ref={textareaRef}

            />
            <div className="count">{headline?.length}/100 | C</div>
          </InputContainer>

          <Divider isOpacity={"40%"} isMargin={"30px 0px 16px 0px"}></Divider>

         
        </StyledBody>
        <Modal.Footer>
          <div className="wrapper">
            <CommonButtonPopup height="40px" width="200px" margin="0" onClick={() => SaveCoachProfileDetails()}  disabled={headline?.length > 100 || !headline || (!imgSrc && !baseImage)}>
              {editState ? "Save" : "Next"}
            </CommonButtonPopup>
          </div>
        </Modal.Footer>
      </>);
  }


  // const pillars = [
  //   "Physical Wellbeing",
  //   "Nutritional Wellbeing",
  //   "Mental Wellbeing",
  //   "Emotional Wellbeing",
  //   "Social Wellbeing",
  //   "Intellectual Wellbeing",
  //   "Occupational Wellbeing",
  //   "Financial Wellbeing",
  //   "Spiritual Wellbeing",
  //   "Environmental Wellbeing",
  //   "Purpose & Contribution",
  //   "Longevity",
  // ];


  const toggleSelect = (pillar) => {
    const isAlready = selectedPillars.some((p) => p.id === pillar.id);
  
    if (isAlready) {
      setSelectedPillars((prev) => prev.filter((p) => p.id !== pillar.id));
    } else {
      if (selectedPillars.length < 3) {
        setSelectedPillars((prev) => [...prev, pillar]);
      } else {
        toast.error("You can select up to 3 pillars only.");
      }
    }
  };


  const stepTwoForm = () => {
    window.console.log("stepOneForm");
    const isNextDisabled = selectedPillars.length === 0;
    return (
      <>
        <Modal.Header closeButton onHide={closeModal} style={{ background: "white" }}>
          <HeaderText>
            <div className="subContainer">
              <div className="popupHeading">Choose Your Core Pillars of Wellbeing</div>
              {editState ? <div className="closeIcon" onClick={()=>closeModal()}>{CloseIconBranding("#092F41")}</div>:null}
            </div>
            <div className="popupSubHeading">Pick up to 3 pillars that reflect your coaching focus. This helps us match you with the right clients and resources.</div>
          </HeaderText>
        </Modal.Header>
        <StyledBody isOverFlow={"hidden"}>
          <WellbeingPillarContainer>
            {/* {selectedAreas.map((pillar, idx) => {
              const isSelected = selectedPillars.includes(pillar) || pillar.user_selected_pillar_priority;
              const order = isSelected ? selectedPillars.indexOf(pillar) + 1 || pillar.user_selected_pillar_priority  : null;
   
              return (
                <WellbeingPillarsCard key={idx} onClick={() => toggleSelect(pillar)}>
                  <CustomCheckBox selected={isSelected}   isBorder={isSelected ? "none" : "1px solid #7C7C7C"}  isBgColor={isSelected ? "#F37A65" : "white"}>{order}</CustomCheckBox>
                  <div className="wellbeing-text">{pillar?.pillar_title}</div>
                </WellbeingPillarsCard>
              );
            })} */}

            {selectedAreas.map((pillar, idx) => {
              const isSelected = selectedPillars.some((p) => p.id === pillar.id);
              const order = isSelected
                ? (selectedPillars.findIndex((p) => p.id === pillar.id) + 1)
                : null;
            
              return (
                <WellbeingPillarsCard 
                  key={idx} 
                  onClick={() => toggleSelect(pillar)}
                >
                  <CustomCheckBox 
                    selected={isSelected} 
                    isBorder={isSelected ? "none" : "1px solid #7C7C7C"}  
                    isBgColor={isSelected ? "#F37A65" : "white"} // use only isSelected
                    // selected={isSelected || pillar.normalized_priority > 0} 
                    // isBorder={isSelected || pillar.normalized_priority > 0 ? "none" : "1px solid #7C7C7C"}  
                    // isBgColor={isSelected || pillar.normalized_priority > 0 ? "#F37A65" : "white"}
                  >
                    {order}
                  </CustomCheckBox>
                  <div className="wellbeing-text">{pillar?.pillar_title}</div>
                </WellbeingPillarsCard>
              );
            })}

          </WellbeingPillarContainer>
          <Divider isOpacity={"40%"} isMargin={"16px 0px 16px 0px"}></Divider>
          <div className="wrapper">
            {!editState ? <CommonButtonBorder width="200px" height="40px"
              onClick={() =>  setStepForPopup(1)}
              margin="0">
              Back
            </CommonButtonBorder>:null}
            <CommonButtonPopup height="40px" width="200px" margin="0" disabled={isNextDisabled} onClick={() =>  setStepForPopup(3)}>
              Next
            </CommonButtonPopup></div></StyledBody>
      </>);}

  // const toggleExpand = (id) => {
  //   setExpanded((prev)=> 
  //     prev.includes(id) ? prev.filter((e)=> e !== id) : [...prev,id]
  //   );
  // } 
  
 


  useEffect(() => {
    if (selectedPillars && selectedPillars.length) {
      setExpanded([selectedPillars[0].id]); // default open first
    }
  }, [selectedPillars]);


  const toggleExpand = (id) => {
    setExpanded((prev) => (prev.includes(id) ? [] : [id]));
  };

  
  // const toggleExpand = (id) => {
  //   setExpanded((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  // };


  // const toggleSubcategory = (pillarId, sub) => {
  //   setSelectedSubcategories((prev) => {
  //     const key = `${pillarId}-${sub.id}`;
  
  //     // get only the selected subcategories for this pillar
  //     const selectedForThisPillar = prev.filter((item) => item.startsWith(`${pillarId}-`));
  
  //     if (prev.includes(key)) {
  //       // unselect
  //       return prev.filter((item) => item !== key);
  //     } else if (selectedForThisPillar.length < 3) {
  //       // only add if < 3 selected for this pillar
  //       return [...prev, key];
  //     }
  
  //     // do nothing if already 3 selected for this pillar
  //     return prev;
  //   });
  // };


  // const toggleSubcategory = (sub) => {
  //   window.console.log("sub",sub)
  //   const key = sub.id;

  //   setSelectedSubcategories((prev) => {
  //     const selectedForThisPillar = prev.filter((item) => item.id === sub.id);
  //     if (prev.includes(key)) {
  //       return prev.filter((item) => item !== key);
  //     } else if (selectedForThisPillar.length < 3) {
  //       return [...prev, key];
  //     }
  //     return prev;
  //   });
  // };




  const toggleSubcategory = (sub) => {
    const key = sub.id;
    setSelectedSubcategories((prev) => {
      if (prev.includes(key)) {
        return prev.filter((item) => item !== key); // remove if already selected
      } else {
        return [...prev, key]; // add if not selected
      }
    });
  };

  
  // helper function
  const isNextEnabled = selectedPillars.every((pillar) => {
    const fullPillar = selectedAreas.find((p) => p.id === pillar.id);
    if (!fullPillar) return false;
    return fullPillar.sub_pillars.some((sub) => selectedSubCategories.includes(sub.id));
  });


  const stepThreeForm = () => {
    window.console.log("stepOneForm");
    return (
      <>
        <Modal.Header closeButton onHide={closeModal} style={{ background: "white" }}>
          <HeaderText>
            <div className="subContainer">
              <div className="popupHeading">Select Your Specialty Areas</div>
              {editState ? <div className="closeIcon" onClick={()=>closeModal()}>{CloseIconBranding("#092F41")}</div>:null}
            </div>
            <div className="popupSubHeading">Choose up to 3 specialties within each pillar you’ve selected to highlight your unique expertise.</div>
          </HeaderText>

        </Modal.Header>
        <StyledBody isOverFlow={"hidden"}> 

          {/* {selectedPillars.map((area) => {
            const isExpanded = expanded.includes(area.id);

            return (
              <div key={area.id} style={{ marginBottom: "16px" }}>
                <WellbeingPillarsCard
                  isWidth={"568px"}
                  style={{
                    justifyContent: "space-between",
                    cursor: "pointer"
                  }}
                  onClick={() => toggleExpand(area.id)}
                >
                  <div className="wellbeing-text">{area.pillar_title}</div>
                  <div style={{ transform: isExpanded ? "rotate(0deg)" : "rotate(270deg)" }}>
                    {DropIcon("#F37A65")}
                  </div>
                </WellbeingPillarsCard>
          
                {isExpanded &&
        // show all sub-pillars, not just selected ones
        area.sub_pillars.map((sub, index) => {
          const isSelected = selectedSubCategories.includes(sub.id); // preselect previously selected ones

          return (
            <WellbeingPillarsCard
              isFontWeight={"400"}
              key={index}
              isWidth={"568px"}
              style={{
                marginTop: "8px",
                justifyContent: "flex-start",
                gap: "12px",
                cursor: "pointer"
              }}
              onClick={() => toggleSubcategory(sub)}
            >
              <CustomCheckBox
                selected={isSelected}
                isBorder={isSelected ? "1px solid #F37A65" : "1px solid #7C7C7C"}
                isBgColor={"white"}
              >
                {isSelected && (
                  <span className="tickIcon">{RecognitionTickIcon("#F37A65")}</span>
                )}
              </CustomCheckBox>
              <div className="wellbeing-text">{sub.title}</div>
            </WellbeingPillarsCard>
          );
        })}
              </div>
            );})} */}
          {selectedPillars.map((selected) => {
            // find full pillar data from master list
            const area = selectedAreas.find((p) => p.id === selected.id);
            if (!area) return null; // safety check
          
            const isExpanded = expanded.includes(area.id);

            return (
              <div key={area.id} style={{ marginBottom: "16px" }}>
                <WellbeingPillarsCard
                  isWidth={"568px"}
                  style={{ justifyContent: "space-between", cursor: "pointer" }}
                  onClick={() => toggleExpand(area.id)}
                >
                  <div className="wellbeing-text">{area.pillar_title}</div>
                  <div style={{ transform: isExpanded ? "rotate(0deg)" : "rotate(270deg)" }}>
                    {DropIcon("#F37A65")}
                  </div>
                </WellbeingPillarsCard>
          
                {isExpanded &&
        area.sub_pillars.map((sub) => {
          const isSelected = selectedSubCategories.includes(sub.id);
          return (
            <WellbeingPillarsCard
              isFontWeight={"400"}
              key={sub.id}
              isWidth={"568px"}
              style={{ marginTop: "8px", justifyContent: "flex-start", gap: "12px", cursor: "pointer" }}
              onClick={() => toggleSubcategory(sub)}
            >
              <CustomCheckBox
                selected={isSelected}
                isBorder={isSelected ? "1px solid #F37A65" : "1px solid #7C7C7C"}
                isBgColor={"white"}
              >
                {isSelected && <span className="tickIcon">{RecognitionTickIcon("#F37A65")}</span>}
              </CustomCheckBox>
              <div className="wellbeing-text">{sub.title}</div>
            </WellbeingPillarsCard>
          );
        })}</div>);
          })}

          {/* {selectedAreas.map((areas.id) => {

            <>
              <WellbeingPillarsCard isWidth={"568px"} style={{justifyContent:"space-between"}}>
                <div className="wellbeing-text">Physical Wellbeing</div>
                <div>{DropIcon("#F37A65")}</div>
              </WellbeingPillarsCard>
  
              <WellbeingPillarsCard isWidth={"568px"} style={{ marginTop: "16px" }}>
                <CustomCheckBox>{RecognitionTickIcon()}</CustomCheckBox>
                <div className="wellbeing-text">Movement & Strength Training</div>
              </WellbeingPillarsCard>
            </>})} */}

          <Divider isOpacity={"40%"} isMargin={"16px 0px 16px 0px"}></Divider>
        </StyledBody>
        <Modal.Footer>
          <div className="wrapper">
            <CommonButtonBorder width="200px" height="40px"
              onClick={() =>  setStepForPopup(2)}
              margin="0">
              Back
            </CommonButtonBorder>
            <CommonButtonPopup height="40px" width="200px" margin="0"    disabled={!isNextEnabled} onClick={() => SaveWellbeingPillarsDetails()}   /*onClick={() => setStep(4)}*/>
              {editState ? "Save" : "Next"}
            </CommonButtonPopup></div>
        </Modal.Footer>
      </>);}




  const stepFourForm = () => {
    window.console.log("stepOneForm");
    return (
      <>
        <Modal.Header closeButton onHide={closeModal} style={{ background: "white" }}>
          <HeaderText>
            <div className="subContainer">
              <div className="popupHeading">Tell Us About Yourself</div>
              {editState ? <div className="closeIcon" onClick={()=>closeModal()}>{CloseIconBranding("#092F41")}</div>:null}
            </div>
            <div className="popupSubHeading">Highlight your experience and passion for wellbeing. This is how clients discover the real you.</div>
          </HeaderText>

        </Modal.Header>
        <StyledBody>
          <InputContainer>
            <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"12px"}>About Yourself</StyledLabel>
            <StyledTextArea
              isBorderColor={title?.length > 100 ? "1px solid #DA6C74" : " 1px solid #BDBDBD"}
              placeholder={("Write about yourself...")}
              name="title"
              height={"144px"}
              onChange={onChangeInput}
              value={title}
              // maxLength="1000"
              isPadding={"14px 16px"}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
            />
            <div className="count"  style={{height:"16px"}}>{title?.length}/1000 | C</div>
          </InputContainer>
          <Divider isOpacity={"40%"} isMargin={"16px 0px 0px 0px"}></Divider>
          <div className="wrapper">
            {!editState ? <CommonButtonBorder width="200px" height="40px"
              onClick={() =>  setStepForPopup(3)}
              margin="0">
                  Back
            </CommonButtonBorder>:null}
            <CommonButtonPopup height="40px" width="200px" margin="0" onClick={() => SaveAboutDetails()} disabled={ title?.length > 1000 || !title}>
              {editState ? "Save" : "Next"}
            </CommonButtonPopup>
          </div>
        </StyledBody> </>);
  }


  const handleTextAreaChange = (e) => {
    const textarea = e.target;
    textarea.style.height = "auto";
    textarea.style.height = `${Math.min(textarea.scrollHeight, 604)}px`; 
    onChangeInputDetails(e);
  };


  const stepFiveForm = () => {
    window.console.log("stepOneForm");
    return (
      <>
        <Modal.Header closeButton onHide={closeModal} style={{ background: "white" }}>
          <HeaderText>
            <div className="subContainer">
              <div className="popupHeading">Add Your Education & Certifications</div>
              {editState ? <div className="closeIcon" onClick={()=>closeModal()}>{CloseIconBranding("#092F41")}</div>:null}
            </div>
            <div className="popupSubHeading">Your qualifications tell the story of your expertise. Add them here to build trust and confidence with clients.</div>
          </HeaderText>

        </Modal.Header>
        <StyledBody>
          <InputContainer>
            <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"12px"}>Education & Certification</StyledLabel>
            <StyledTextAreaAutoSize
              isMaxHeight={"336px"}
              placeholder={("Enter education or certification details")}
              name="certificateDescription"
              onChange={handleTextAreaChange}
              value={certificateDescription}
              isPadding={"12px"}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
              ref={textareaRef}
            />
          </InputContainer>
          <Divider isOpacity={"40%"} isWidth={"95%"} isMargin={"16px 13px"}></Divider>
          
        </StyledBody>
        <Modal.Footer>
          <div className="wrapper">
            {!editState  ? <CommonButtonBorder width="200px" height="40px"
              onClick={() =>  setStepForPopup(4)}
              margin="0">
                            Back
            </CommonButtonBorder> : null}
            <CommonButtonPopup height="40px" width="200px" margin="0" onClick={() => SaveEducationCertificationDetails()} /*onClick={()=>  setStep(6)} */ >
              {editState ? "Save" : "Next"}
            </CommonButtonPopup>
          </div>
        </Modal.Footer>
      </>);}

  // const dummyData = ["English", "Arabic", "Marathi", "French", "German"];


 
  

  // const handleSelectItem = (item) => {
  //   setSelectedItems((prev) =>
  //     prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
  //   );
  // };

  const handleSelectItem = (item) => {
    setSelectedItems((prev) => {
      const exists = prev.find((i) => i.id === item.id);
      if (exists) {
        return prev.filter((i) => i.id !== item.id);
      } else {
        return [...prev, item];
      }
    });
  };
  

  const removeTag = (item) => {
    setSelectedItems((prev) => prev.filter((i) => i !== item));
  };

 
  const stepSixForm = () => {
    window.console.log("stepOneForm");
    return (
      <>
        <Modal.Header closeButton onHide={closeModal} style={{ background: "white" }}>
          <HeaderText>
            <div className="subContainer">
              <div className="popupHeading">Share Your Coaching Style & Basics</div>
              {editState ? <div className="closeIcon" onClick={()=>closeModal()}>{CloseIconBranding("#092F41")}</div>:null}
            </div>
            <div className="popupSubHeading">Help clients get to know you—share your languages, coaching style, and ideal client focus.</div>
          </HeaderText>
        </Modal.Header>
        <StyledBody style={{minHeight:"425px"}}>
          <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"12px"}>Languages</StyledLabel>
          <div style={{ width: "100%", position: "relative" }}>
            <div
              onClick={toggleDropdown}
              style={{
                border: "1px solid #BDBDBD",
                padding: "14px 16px",
                borderRadius: "4px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap", // allows multiple tags to wrap inside
                minHeight: "40px", // make it taller to fit tags
                gap: "4px",
              }}
            >
              {selectedItems.length === 0 && <span style={{ color: "#999" }}>Select Languages</span>}
            
              {selectedItems.map((item, index) => (
                <TagUserCard key={index}>
                  <div className="name">{item.name}</div>
                  <div onClick={(e) => { e.stopPropagation(); removeTag(item); }} style={{ cursor: "pointer" }}>
                    {closeIcon("#F37A65","8px","8px")}
                  </div>
                </TagUserCard>
              ))}
            
              <span style={{ marginLeft: "auto", transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)" }}>
                {DropIcon("#F37A65")}
              </span>
            </div>
  
            {dropdownOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  border: "1px solid #bdbdbd",
                  backgroundColor: "#fff",
                  zIndex: 10,
                  maxHeight: "200px",
                  overflowY: "auto",
                  marginTop: "2px",
                  borderRadius: "4px",
                }}
              >
                {coachLanguages.map((item, index) => {
                  const isSelected = selectedItems.some((i) => i.id === item.id);
                  return(
                
                    <div
                      key={index}
                      onClick={() => handleSelectItem(item)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between", 
                        padding: "8px 12px",
                        color: "#184A61",
                        cursor: "pointer",
                      }}
                    >
                      <span style={{fontSize:"16px",color:"#184A61",fontFamily:"Lato",fontWeight:"400"}}>{item.name}</span>
                      {/* <input
                      type="checkbox"
                      checked={selectedItems.includes(item)}
                      readOnly
                    /> */}
                      <ManagerIconContainer selected={isSelected? true : false}>
                        <div
                          className="archive-action"
                        >
                          {isSelected
                            ? RecognitionTickIcon()
                            : null}
                        </div>
                      </ManagerIconContainer>
                    </div>
                  )})}
              </div>
            )}
          </div>

          {/* <InputContainer>
            <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"12px"}>Languages</StyledLabel>
            <StyledTextAreaAutoSize
              placeholder={("Select languages")}
              name="coachingStyle"
              onChange={handleTextAreaChange}
              value={coachingStyle}
              isPadding={"14px 16px"}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
            />
          </InputContainer> */}
          <InputContainer>
            <StyledLabel isFont={"14px"} color={"#184A61"} margin="16px" symbolSize={"14px"} marginb={"12px"}>Coaching Style</StyledLabel>
            {/* <StyledTextAreaAutoSize
              placeholder={("Holistic, goal-focused, supportive")}
              name="coachingStyle"
              onChange={handleTextAreaChange}
              value={coachingStyle}
              isPadding={"14px 16px"}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
            /> */}


            <StyledInput
              placeholder={("Holistic, goal-focused, supportive")}
              name="coachingStyle"
              onChange={onChangeInput}
              value={coachingStyle}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
            />
          </InputContainer>
          <InputContainer>
            <StyledLabel isFont={"14px"} color={"#184A61"} margin="16px" symbolSize={"14px"} marginb={"12px"}>Client Type Focus</StyledLabel>
            {/* <StyledTextAreaAutoSize
              placeholder={("Busy professionals, athletes, new parents")}
              name="clientType"
              onChange={handleTextAreaChange}
              value={clientType}
              isPadding={"14px 16px"}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
            /> */}
            <StyledInput
              placeholder={("Busy professionals, athletes, new parents")}
              name="clientType"
              onChange={onChangeInput}
              value={clientType}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
            />
          </InputContainer>
          <InputContainer>
            <StyledLabel isFont={"14px"} color={"#184A61"} margin="16px" symbolSize={"14px"} marginb={"12px"}>Years of Experience</StyledLabel>
            {/* <StyledTextAreaAutoSize
              type="number"
              placeholder={("Enter years of experience")}
              name="experience"
              onChange={handleTextAreaChange}
              value={experience}
              isPadding={"14px 16px"}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
            /> */}


            <StyledInput
              placeholder={("Enter years of experience")}
              name="experience"
              onChange={onChangeInput}
              value={experience}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
            />
          </InputContainer>
          <Divider  isOpacity={"40%"} isMargin={"16px 0px 0px 0px"}></Divider>
        
        </StyledBody>
        <Modal.Footer>
          <div className="wrapper">
            {!editState  ? <CommonButtonBorder width="200px" height="40px"
              onClick={() =>  setStepForPopup(5)}
              margin="0">
                            Back
            </CommonButtonBorder>: null}
            <CommonButtonPopup height="40px" width="200px" margin="0" onClick={() => SaveCoachStylesDetails()} >
              {editState ? "Save" : "Next"}
            </CommonButtonPopup>
          </div>
        </Modal.Footer>
      </>);}


  const stepSevenForm = () => {
    window.console.log("stepOneForm");
    return (
      <>
        <Modal.Header closeButton onHide={closeModal} style={{ background: "white" }}>
          <HeaderText>
            <div className="subContainer">
              <div className="popupHeading">Show a Little Personality</div>
              {editState ? <div className="closeIcon" onClick={()=>closeModal()}>{CloseIconBranding("#092F41")}</div>:null}
            </div>
            <div className="popupSubHeading">These little things make a big difference—let clients connect with the person behind the coach.</div>
          </HeaderText>
        </Modal.Header>
        <StyledBody isOverFlow={"auto"} style={{minHeight:"385px"}}>

          <InputContainer>
            <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"12px"}>Spirit Veggie or Fruit</StyledLabel>
            {/* <StyledTextArea
              placeholder={("Avocado — smooth, adaptable, and full of energy")}
              isBorderColor={favoriteVeggieFruit?.length > 100 ? "1px solid #DA6C74" : " 1px solid #BDBDBD"}
              name="favoriteVeggieFruit"
              height={"48px"}
              onChange={handleTextAreaChange}
              value={favoriteVeggieFruit}
              isPadding={"12px"}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
              ref={textareaRef}
            /> */}

            <StyledTextAreaAutoSize
              rows={1} //
              isHeight={"auto"}
              placeholder={("Avocado — smooth, adaptable, and full of energy")}
              isBorderColor={favoriteVeggieFruit?.length > 100 ? "1px solid #DA6C74" : " 1px solid #BDBDBD"}
              name="favoriteVeggieFruit"
              onChange={handleTextAreaChange}
              value={favoriteVeggieFruit}
              isPadding={"12px"}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
              ref={textareaRef}
            />
            <div className="count" style={{color: favoriteVeggieFruit?.length > 100 ? "#DA6C74" : "#BDBDBD",  height:"16px" }}>{favoriteVeggieFruit?.length}/100 | C</div>
          </InputContainer>

          <InputContainer>
            <StyledLabel isFont={"14px"} color={"#184A61"} margin="16px" symbolSize={"14px"} marginb={"12px"}>Favorite Place to Vacation</StyledLabel>
            {/* <StyledTextArea
              isBorderColor={favoritePlace?.length > 100 ? "1px solid #DA6C74" : " 1px solid #BDBDBD"}
              placeholder={("Relaxing on the beaches of Bali")}
              name="favoritePlace"
              height={"48px"}
              onChange={handleTextAreaChange}
              value={favoritePlace}
              isPadding={"12px"}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
              ref={textareaRef}
            /> */}
            <StyledTextAreaAutoSize
              rows={1} //
              isHeight={"auto"}
              placeholder={("Relaxing on the beaches of Bali")}
              isBorderColor={favoritePlace?.length > 100 ? "1px solid #DA6C74" : " 1px solid #BDBDBD"}
              name="favoritePlace"
              onChange={handleTextAreaChange}
              value={favoritePlace}
              isPadding={"12px"}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
              ref={textareaRef}

            />
            <div className="count" style={{color: favoritePlace?.length > 100 ? "#DA6C74" : "#BDBDBD" , height:"16px" }}>{favoritePlace?.length}/100 | C</div>
          </InputContainer>
          <InputContainer>
            <StyledLabel isFont={"14px"} color={"#184A61"} margin="16px" symbolSize={"14px"} marginb={"12px"}>Wellness Superpower</StyledLabel>
            {/* <StyledTextArea
              placeholder={("Guided meditation in under 60 seconds")}
              isBorderColor={wellnesSuperpower?.length > 100 ? "1px solid #DA6C74" : " 1px solid #BDBDBD"}
              name="wellnesSuperpower"
              onChange={handleTextAreaChange}
              value={wellnesSuperpower}
              isPadding={"12px"}
              height={"48px"}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
              ref={textareaRef}
            /> */}
            <StyledTextAreaAutoSize
              rows={1} //
              isHeight={"auto"}
              placeholder={("Guided meditation in under 60 seconds")}
              isBorderColor={wellnesSuperpower?.length > 100 ? "1px solid #DA6C74" : " 1px solid #BDBDBD"}
              name="wellnesSuperpower"
              onChange={handleTextAreaChange}
              value={wellnesSuperpower}
              isPadding={"12px"}
              style={{ background: "white" }}
              pColor={"#BDBDBD"}
              color="#184A61"
              border={"1px solid #BDBDBD"}
              ref={textareaRef}

            />
            <div className="count" style={{color: wellnesSuperpower?.length > 100 ? "#DA6C74" : "#BDBDBD", height:"16px" }}>{wellnesSuperpower?.length}/100 | C</div>
          </InputContainer>
          <Divider isMargin={"16px 0px 0px 0px"}></Divider>

          
        </StyledBody>
        <Modal.Footer>
          <div className="wrapper">
            {!editState  ? <CommonButtonBorder width="200px" height="40px"
              onClick={() =>  setStepForPopup(6)}
              margin="0">
                Back
            </CommonButtonBorder>:null}
            <CommonButtonPopup height="40px" width="200px" margin="0"
              disabled={favoriteVeggieFruit?.length > 100 || favoritePlace?.length > 100 || wellnesSuperpower?.length > 100}
              onClick={() => SavePersonalityDetails()}>
                Save
            </CommonButtonPopup>
          </div>
        </Modal.Footer>
      </>);
  }




  return (
    window.console.log("showModal", showModal),
    <>
      {showModal && <StyledModal  maxHeight={step === 5 ? "604px" : ""}     show={showModal} newWidth="600px" newHeight={step === 1 ? "658px" : step === 2 ? "555px" : step === 3 ? "564px" : step === 4 ? "407px" : step === 5 ? "" : step === 6 ? "590px" : step === 7 ? "548px" : "407px"} newBg={step === 1 ? "#EEB3B4 !important" :
        step === 2 ? "#E1C0D1 !important" :
          step ===3 ? "#E1C0D1 !important" :
            step === 4 ? "#D3DEF2 !important" :
              step === 5 ? "#FDD2CB !important" :
                step === 6 ? "#EED5BA !important" :
                  step === 7? "#BDDDC2 !important" :
                    "white !important"}>

        {step === 1 ? stepOneForm() :
          step === 2 ? stepTwoForm() :
            step === 3 ? stepThreeForm() :
              step === 4 ? stepFourForm() :
                step === 5 ? stepFiveForm() :
                  step === 6 ? stepSixForm() :
                    step === 7 ? stepSevenForm() :
                      null}
      </StyledModal>}
    </>)

}

ProfileDetailsPopup.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  userName: PropTypes.string,
  coachData: PropTypes.object,
  setStepForPopup: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  editState: PropTypes.bool.isRequired,
  GetCoachProfileData: PropTypes.func.isRequired,
  loggedInUserID:PropTypes.number.isRequired,
  employeeId:PropTypes.number.isRequired,
  dropdownOpen:PropTypes.bool.isRequired,
  toggleDropdown:PropTypes.func.isRequired,
}



export default ProfileDetailsPopup;